/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import NoteListComponent from './NoteListComponent';

const useStyles = makeStyles((theme) => ({
  container:{
    position: 'absolute',
    top: 65,
    left: '-5rem',
    width: 'auto',
    maxHeight: 300,
    zIndex: 1000,
    transform: 'translateX(-45%)',
    padding: theme.spacing(3),
    boxShadow: theme.palette.shadow.footer,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 5,
    overflow: 'auto',
    overflowX: 'hidden'
  }
}));

const NotesDisplay = ({displayNotes, isLoadingProductTests, productTestsNotes, setDisplayNotes}) => {
  const classes = useStyles();

  return (
    <div
      className={classes.container}
    >
      <Grid container direction='column' spacing={2}>
        <NoteListComponent
          data={productTestsNotes}
          displayNotes={displayNotes}
          isLoading={isLoadingProductTests}
          setDisplayNotes={setDisplayNotes}
          title="newNotesProductTests"/>
        {/* <NoteListComponent data={auditsNotes} isLoading={isLoadingAuditsNotes} title="newNotesAudits"/> */}
      </Grid>
    </div>
  );
};

export default NotesDisplay;